module.exports = [{"name":"Data Processing Addendum (DPA)","papers":[{"title":"Data Processing Addendum","id":"auth0-dpa","icon":"https://cdn.auth0.com/website/assets/pages/legals/img/icon-acrobat-7d1807772f.svg","date":"January, 2019","actions":[{"action":"download","file":"https://cdn.auth0.com/website/legal/files/auth0-dpa-19.pdf"},{"action":"open","file":"https://cdn.auth0.com/website/legal/files/auth0-dpa-19.pdf"}]}]}]


//////////////////
// WEBPACK FOOTER
// ./src/pages/legals/dpa/data/dpaPapers.json
// module id = 1645
// module chunks = 0